/**
 * Counter animation — view script for mnorwise/counter-number block.
 *
 * Loaded only on pages that contain this block.
 * Targets the block's own wrapper class so it works regardless of theme.
 */

function animateCounter(el) {
	const target = parseFloat(el.dataset.target);
	if (isNaN(target)) return;

	const duration = parseInt(el.dataset.duration, 10) || 2000;
	const prefix = el.dataset.prefix || '';
	const suffix = el.dataset.suffix || '';
	const isDecimal = String(el.dataset.target).includes('.');
	const decimals = isDecimal
		? (el.dataset.target.split('.')[1] || '').length
		: 0;

	const startTime = performance.now();

	function step(now) {
		const progress = Math.min((now - startTime) / duration, 1);
		const eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
		const current = eased * target;

		el.textContent =
			prefix +
			(decimals
				? current.toFixed(decimals)
				: Math.floor(current).toLocaleString()) +
			suffix;

		if (progress < 1) {
			requestAnimationFrame(step);
		} else {
			el.textContent =
				prefix +
				(decimals
					? target.toFixed(decimals)
					: target.toLocaleString()) +
				suffix;
		}
	}

	requestAnimationFrame(step);
}

const counters = document.querySelectorAll(
	'.wp-block-mnorwise-counter-number[data-target]'
);

if (counters.length) {
	if ('IntersectionObserver' in window) {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						animateCounter(entry.target);
						observer.unobserve(entry.target);
					}
				});
			},
			{ threshold: 0.3 }
		);
		counters.forEach((el) => observer.observe(el));
	} else {
		counters.forEach((el) => {
			const target = parseFloat(el.dataset.target);
			if (isNaN(target)) return;
			const isDecimal = String(el.dataset.target).includes('.');
			const decimals = isDecimal
				? (el.dataset.target.split('.')[1] || '').length
				: 0;
			el.textContent =
				(el.dataset.prefix || '') +
				(decimals
					? target.toFixed(decimals)
					: target.toLocaleString()) +
				(el.dataset.suffix || '');
		});
	}
}
